import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';

import ReferralTierTable from './ReferralTierTable';
import TierUpdateButton from './TierUpdateButton';
import useTierList from './useTierList';

export const ReferralTierListTab = () => {
  const {isLoading, fetchList, total, list} = useTierList('referral');
  return (
    <main className="my-5">
      <PermissionsProvider
        permission={AfriexAdminPermission.ReferralTierManage}
      >
        <div className="flex justify-end">
          <TierUpdateButton isMerchant={false} />
        </div>
      </PermissionsProvider>

      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : <ReferralTierTable items={list} />}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};
